import { useMemo } from 'react';
import { tintScale } from '@vitness/tokens';
import { useTheme } from './ThemeProvider.js';

export interface AccentValue {
  color: string;
  safe: string;
  rgb: { r: number; g: number; b: number };
  name: string;
  tintScale: typeof tintScale;
  tint: (step: number) => string;
}

export function useAccent(): AccentValue {
  const { accent, accentSafe, accentRgb, accentName } = useTheme();

  return useMemo(() => ({
    color: accent,
    safe: accentSafe,
    rgb: accentRgb,
    name: accentName,
    tintScale,
    tint(step: number): string {
      const opacity = tintScale[step] ?? step;
      return `rgba(${accentRgb.r},${accentRgb.g},${accentRgb.b},${opacity})`;
    },
  }), [accent, accentSafe, accentRgb, accentName]);
}
